import BlDropAreaMv from './BlDropAreaMv.vue'

BlDropAreaMv.install = function(Vue) {
  Vue.component(BlDropAreaMv.name, BlDropAreaMv)
}

export default BlDropAreaMv
